import { useState } from 'react';
import { useSignUpMutation } from '../store/services/userApi';
import { useNavigate } from 'react-router-dom';

const Signup = () => {
  const navigate = useNavigate();
  const [signUp, { isLoading, error }] = useSignUpMutation();
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    customer_name: '',
    customer_mobile: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await signUp(formData).unwrap();
      navigate('/');
    } catch (err) {
      console.error('Signup Error:', err);
    }
  };

  return (
    <div className="max-w-md mx-auto p-8 border border-gray-300 rounded-lg bg-white shadow-lg">
      <h2 className="text-center text-xl font-semibold mb-6">Signup</h2>
      {error && <p className="text-red-500 text-center mb-4">{error?.data?.message || 'Something went wrong'}</p>}
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="username"
          placeholder="Username"
          className="w-full p-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={formData.username}
          onChange={handleChange}
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          className="w-full p-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={formData.password}
          onChange={handleChange}
        />
        <input
          type="text"
          name="customer_name"
          placeholder="Customer Name"
          className="w-full p-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={formData.customer_name}
          onChange={handleChange}
        />
        <input
          type="text"
          name="customer_mobile"
          placeholder="Customer Mobile"
          className="w-full p-2 mb-6 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={formData.customer_mobile}
          onChange={handleChange}
        />
        <button
          type="submit"
          className="w-full p-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition duration-200"
          disabled={isLoading}
        >
          {isLoading ? 'Signing Up...' : 'Sign Up'}
        </button>
      </form>
    </div>
  );
};

export default Signup;
